import React from "react"
import PropTypes from "prop-types"
import StandardModal from './StandardModal'

class ProModal extends React.Component {
  constructor(props) {
    super(props)

    this.headerText = this.headerText.bind(this)
    this.sectionText = this.sectionText.bind(this)
    this.onClick = this.onClick.bind(this)
  }

  headerText() {
    switch (this.props.type) {
      case 'filter':
        return 'You discovered a Pro filter!'
      case 'id':
        return 'Upgrade to verify your profile'
      case 'extended':
        return 'Unlock the Extended pack'
      default:
        return 'You discovered a Pro feature!'
    }
  }

  sectionText() {
    switch (this.props.type) {
      case 'filter':
        return 'To unlock and use this filter, upgrade to Pro today!'
      case 'id':
        return 'To see only verified members, you must verify your profile first. Upgrade to confirm it is really you!'
      case 'extended':
        return 'Upgrade to Pro to play with every picture. A partner with Pro can unlock it too.'
      default:
        return 'To unlock and use this feature, upgrade to Pro today!'
    }
  }

  onClick() {
    switch (this.props.type) {
      case 'id':
        window.location.assign('/verify_identity_steps')
        break
      default:
        window.location.assign('/pricing')
    }
  }

  render() {
    return (
      <StandardModal
        onClose={this.props.onClose}
        title={this.headerText()}
        modalClass="proModal"
        overlayClass="celebrationModalOverlay"
      >
        <div className="proModal__content">
          <span className="proModal__eyebrow">Pro</span>

          <img
            className="proModal__image"
            src={this.props.premiumImage}
            alt=""
          />

          <h2 className="proModal__title">{this.headerText()}</h2>
          <p className="proModal__text">{this.sectionText()}</p>

          <button type="button" className="proModal__cta" onClick={this.onClick}>
            Upgrade Now
          </button>
        </div>
      </StandardModal>
    )
  }
}

ProModal.propTypes = {
  type: PropTypes.string,
  premiumImage: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default ProModal
